import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import GrammaPro from './component';
import ViewNav from 'components/ViewNav';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';

export default ({ getState }) => ({
  appBars: {
    sticky: {
      'view-nav': {
        component: ViewNav,
        order: 3,
        props: {
          hideExpandable: true,
        },
      },
    },
  },
  path: 'grammar-pro',
  component: GrammaPro,
  canAccess: ({ params }) =>
  PrivilegeChecker.hasPrivilege(getState(), Privileges.Homework.View) &&
  TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.GrammaPro),
  breadcrumbLabels: {
    label: 'Grammar-pro',
    clickable: false,
  },
  tab: {
    label: 'grammar-pro',
    order: 11,
    isVisible: (params) =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.Homework.View) &&
    TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.GrammaPro),
  },
});



// WEBPACK FOOTER //
// ./containers/Group/GrammaPro/routes.js